import type { TRootState } from 'store';
import type { ISelector } from 'interfaces/Selector.interface';
import { createSelectorSlice } from 'redux/collections/helper/createSelector.slice';
import {
  currentPageDefault,
  itemsPerPageDefault,
} from 'redux/collections/consts/selectorDefaults.consts';

export const invoicesSlice = createSelectorSlice(
  'paginatedInvoices',
  currentPageDefault,
  itemsPerPageDefault,
  { columnKey: 'createdAt', direction: 'desc' }
);

const { actions, reducer } = invoicesSlice;

export const {
  setPagination,
  setNextPage,
  setSorting,
  setItemsPerPage,
  setFilters,
} = actions;

export const paginatedInvoicesSelector = (state: TRootState): ISelector =>
  state.collectionInvoices;

export default reducer;
